/* Shared storefront validation. This does not replace server-side checkout validation. */
(() => {
  if (window.ifServiceValidation) return;
  const messages = document.currentScript?.dataset || {};
  const platforms = /facebook|instagram|tiktok|youtube|twitter|spotify|threads|linkedin|telegram|twitch|vimeo/;
  const clean = value => String(value || '').trim();
  function rule(identity, label = '') {
    const text = String(identity).toLowerCase();
    const hint = String(label).toLowerCase();
    const platform = text.match(platforms)?.[0] || hint.match(platforms)?.[0];
    if (!platform) return null;
    const has = pattern => pattern.test(text);
    let target = 'post';
    switch (platform) {
      case 'facebook': target = has(/website/) ? 'website' : has(/group/) ? 'group' : has(/followers|auto-likes/) ? 'profile' : has(/views/) ? 'video' : has(/photo|post|shares|comments|reactions/) ? 'post' : has(/video/) || /video/.test(hint) && !/post|photo/.test(hint) ? 'video' : 'profile'; break;
      case 'instagram': target = has(/followers|subscription|auto-likes/) || /profile/.test(hint) ? 'profile' : 'post'; break;
      case 'tiktok': target = has(/followers|live/) ? 'profile' : has(/likes/) ? 'post' : 'video'; break;
      case 'youtube': target = has(/subscribers/) ? 'channel' : has(/community/) ? 'post' : 'video'; break;
      case 'twitter': target = has(/followers/) || /profile/.test(hint) ? 'profile' : 'post'; break;
      case 'spotify': target = has(/playlist/) ? 'playlist' : has(/followers|monthly-listeners/) || /artist/.test(hint) ? 'artist' : has(/plays/) ? 'track or episode' : 'track'; break;
      case 'threads': target = has(/followers/) ? 'profile' : 'post'; break;
      case 'linkedin': target = has(/followers|connections/) ? 'profile' : 'post'; break;
      case 'telegram': target = has(/members/) ? 'group' : 'post'; break;
      case 'twitch': target = has(/followers|live/) ? 'profile' : 'video'; break;
      case 'vimeo': target = has(/followers|subscribers/) ? 'profile' : 'video'; break;
    }
    return { platform, target };
  }
  function urlValid(value, selected) {
    const raw = clean(value);
    if (!raw || /[\s\\]/.test(raw)) return false;
    let url;
    try { url = new URL(raw); } catch { return false; }
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return false;
    const h = url.hostname.toLowerCase(), p = url.pathname.replace(/\/+$/, ''), q = url.searchParams;
    if (!selected) return true;
    const { platform, target } = selected;
    const host = (...values) => values.includes(h);
    const profile = reserved => /^\/[\w.-]+$/.test(p) && !reserved.includes(p.slice(1).toLowerCase());
    switch (platform) {
      case 'facebook': {
        if (target === 'website') return Boolean(h.includes('.'));
        if (!host('www.facebook.com', 'm.facebook.com')) return false;
        if (/^\/share\/(?![prv]$)[A-Za-z0-9_-]+$/.test(p)) return true;
        const video = /^\/(?:[^/]+\/)?videos\/[^/]+/.test(p) || /^\/reel\/[^/]+$/.test(p) || p === '/watch' && Boolean(q.get('v'));
        const post = video || /\/(?:posts|photos|permalink)\//.test(p) || /^\/(?:photo|photo.php)$/.test(p) && Boolean(q.get('fbid')) || /^\/(?:permalink.php|story.php)$/.test(p) && Boolean(q.get('story_fbid')) || /^\/share\/(?:p|r|v)\/[^/]+$/.test(p);
        if (target === 'video') return video || /^\/share\/[rv]\/[^/]+$/.test(p);
        if (target === 'post') return post;
        if (target === 'group') return /^\/groups\/[^/]+$/.test(p);
        return profile(['watch','reel','groups','login','share','photo.php','story.php','permalink.php','profile.php','help','settings']) || p === '/profile.php' && /^\d+$/.test(q.get('id') || '') || /^\/people\/[^/]+\/\d+$/.test(p) || /^\/pages\/[^/]+\/\d+$/.test(p);
      }
      case 'instagram':
        if (!host('instagram.com','www.instagram.com','m.instagram.com')) return false;
        return target === 'profile' ? profile(['p','reel','reels','tv','explore','accounts','direct','stories']) : /^\/(?:p|reel|reels|tv)\/[\w-]+$/.test(p);
      case 'tiktok':
        if (host('vm.tiktok.com','vt.tiktok.com')) return /^\/[A-Za-z0-9_-]+$/.test(p);
        if (!host('www.tiktok.com','tiktok.com','m.tiktok.com')) return false;
        if (/^\/t\/[A-Za-z0-9_-]+$/.test(p)) return true;
        return target === 'profile' ? /^\/@[\w.]+(?:\/live)?$/.test(p) : target === 'post' ? /^\/@[\w.]+\/(?:video|photo)\/\d+$/.test(p) : /^\/@[\w.]+\/video\/\d+$/.test(p);
      case 'youtube':
        if (target === 'video' && host('youtu.be')) return /^\/[\w-]{11}$/.test(p);
        if (!host('youtube.com','www.youtube.com','m.youtube.com','music.youtube.com')) return false;
        if (target === 'channel') return /^\/(?:@[^/]+|channel\/UC[\w-]+|(?:c|user)\/[^/]+)(?:\/(?:featured|videos|shorts|streams|playlists|community|about))?$/.test(p);
        if (target === 'post') return /^\/post\/[\w-]+$/.test(p) || /\/community$/.test(p) && Boolean(q.get('lb'));
        return p === '/watch' && /^[\w-]{11}$/.test(q.get('v') || '') || /^\/(?:shorts|live|embed)\/[\w-]{11}$/.test(p);
      case 'twitter':
        if (!host('x.com','www.x.com','twitter.com','www.twitter.com','mobile.twitter.com')) return false;
        return target === 'profile' ? /^\/[\w]{1,15}$/.test(p) && !['/home','/search','/explore','/settings','/intent','/i'].includes(p.toLowerCase()) : /^\/(?:[\w]{1,15}\/status|i\/web\/status)\/\d+$/.test(p);
      case 'spotify': return host('open.spotify.com') && new RegExp('^/(?:intl-[a-z]{2}/)?' + (target === 'track or episode' ? '(?:track|episode)' : target) + '/[A-Za-z0-9]{22}$').test(p);
      case 'threads':
        if (!host('threads.net','www.threads.net','threads.com','www.threads.com')) return false;
        return target === 'profile' ? /^\/@[\w.]+$/.test(p) : /^\/@[\w.]+\/post\/[\w-]+$/.test(p);
      case 'linkedin':
        if (!host('linkedin.com','www.linkedin.com','m.linkedin.com')) return false;
        return target === 'profile' ? /^\/(?:in|company|school)\/[^/]+$/.test(p) : /^\/posts\/[^/]+$/.test(p) || /^\/feed\/update\/urn:li:(?:activity|share|ugcPost):\d+$/.test(p);
      case 'telegram':
        if (!host('t.me','telegram.me','www.t.me')) return false;
        return target === 'group' ? /^\/(?:[A-Za-z][\w]{3,}|\+[\w-]+|joinchat\/[\w-]+)$/.test(p) && !/^\/(?:share|proxy|socks|login)$/.test(p) : /^\/(?:s\/)?[A-Za-z][\w]{3,}\/\d+$/.test(p) || /^\/c\/\d+\/\d+$/.test(p);
      case 'twitch':
        if (target === 'video' && host('clips.twitch.tv')) return /^\/[\w-]+$/.test(p);
        if (!host('twitch.tv','www.twitch.tv','m.twitch.tv')) return false;
        return target === 'profile' ? /^\/[\w]{3,25}$/.test(p) && !/^\/(?:directory|downloads|settings|videos|search)$/.test(p) : /^\/videos\/\d+$/.test(p) || /^\/[\w]+\/clip\/[\w-]+$/.test(p);
      case 'vimeo':
        if (target === 'video' && host('player.vimeo.com')) return /^\/video\/\d+$/.test(p);
        if (!host('vimeo.com','www.vimeo.com')) return false;
        return target === 'profile' ? /^\/[A-Za-z][\w-]*$/.test(p) && !/^\/(?:watch|search|categories|channels|groups|ondemand|features|log_in|join)$/.test(p) : /^\/\d+(?:\/[a-f0-9]+)?$/.test(p) || /^\/(?:channels\/[^/]+|groups\/[^/]+\/videos)\/\d+$/.test(p);
      default: return false;
    }
  }
  let sequence = 0;
  function setError(field, message) {
    field.setCustomValidity(message);
    field.setAttribute('aria-invalid', 'true');
    if (!field.dataset.serviceErrorId) field.dataset.serviceErrorId = `if-service-error-${++sequence}`;
    let error = document.getElementById(field.dataset.serviceErrorId);
    if (!error) {
      error = document.createElement('p'); error.id = field.dataset.serviceErrorId;
      error.setAttribute('role','alert'); error.style.cssText = 'color:#b91c1c;font-size:14px;margin:6px 0;';
      field.after(error);
      field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'),error.id].filter(Boolean).join(' '));
    }
    error.hidden = false; error.textContent = message;
    field.focus(); field.reportValidity();
  }
  function clear(field) {
    if (!field.dataset.serviceErrorId) return;
    field.setCustomValidity(''); field.removeAttribute('aria-invalid');
    const error = document.getElementById(field.dataset.serviceErrorId);
    if (error) error.hidden = true;
  }
  function identityFor(form) {
    const scope = form.closest('[data-service-identity]') || (form.getAttribute('id') === 'service-atc-form' ? document.querySelector('product-form[data-service-identity]') : null);
    if (!scope) return null;
    const variant = form.elements.namedItem('id')?.value;
    const radio = [...scope.querySelectorAll('input[data-variant-id]')].find(x => x.dataset.variantId === variant);
    return radio?.dataset.serviceIdentity || scope.dataset.serviceIdentity;
  }
  function validateForm(form) {
    if (!(form instanceof HTMLFormElement)) return true;
    const identity = identityFor(form);
    if (!identity) return true;
    const fields = [...form.elements];
    const link = fields.find(x => x.matches('[data-service-link], [data-username], [ref="socialLink"]'));
    if (!link) return true; // Non-link products use their own form requirements.
    // Existing username controls synchronise a hidden canonical URL; keep their validator.
    if (link.type === 'hidden') return true;
    clear(link);
    const selected = rule(identity, link.name);
    if (selected && !urlValid(link.value, selected) || !clean(link.value)) {
      const brands = {facebook:'Facebook',instagram:'Instagram',tiktok:'TikTok',youtube:'YouTube',twitter:'X / Twitter',spotify:'Spotify',threads:'Threads',linkedin:'LinkedIn',telegram:'Telegram',twitch:'Twitch',vimeo:'Vimeo'};
      const target = selected ? `${brands[selected.platform]} ${selected.target}` : '';
      setError(link, (messages.invalid || 'Use a full HTTPS __TARGET__ link. Check the domain and destination.').replace('__TARGET__', target));
      return false;
    }
    link.value = clean(link.value);
    // Secondary URL fields (for example Spotify artist links in track bundles).
    for (const field of fields.filter(x => x.matches('textarea[name^="properties["]'))) {
      if (/link|url/i.test(field.name) && /spotify/i.test(field.name)) {
        clear(field);
        if (!urlValid(field.value, rule('spotify-followers',field.name))) {
          setError(field,(messages.invalid || 'Use a full HTTPS __TARGET__ link.').replace('__TARGET__','Spotify artist')); return false;
        }
      }
    }
    return form.reportValidity();
  }
  function validCartRecord(record) {
    const selected = rule(record.identity, record.label);
    if (record.label && !clean(record.link)) return false;
    if (selected && !urlValid(record.link,selected)) return false;
    if (record.secondLabel && !clean(record.second)) return false;
    if (record.reactionOptions?.length && !record.reactionOptions.includes(record.reaction)) return false;
    const limits = window.ifCommentValidation?.limits(record.handle);
    if (limits && record.secondLabel) {
      const count = window.ifCommentValidation.lines(record.second).length;
      if (count < limits.min || count > limits.max) return false;
    }
    if (/spotify/i.test(record.secondLabel || '') && /link/i.test(record.secondLabel || '') && !urlValid(record.second,rule('spotify-followers'))) return false;
    return true;
  }
  function validateCart() {
    let valid = true;
    document.querySelectorAll('[data-service-cart-record]').forEach(node => {
      let ok = false;
      try { ok = validCartRecord(JSON.parse(node.dataset.serviceCartRecord)); } catch { /* Keep checkout blocked on invalid metadata. */ }
      const warning = node.querySelector('[data-service-cart-warning]');
      if (warning) warning.hidden = ok;
      if (!ok) valid = false;
    });
    document.querySelectorAll('[data-service-checkout]').forEach(button => {
      button.disabled = !valid || button.dataset.checkoutBlocked === 'true';
    });
    document.querySelectorAll('[data-service-accelerated]').forEach(node => { node.hidden = !valid; });
    return valid;
  }
  function guard(event) {
    const button = event.type === 'click' ? event.target.closest('button[type="submit"],input[type="submit"]') : null;
    const form = button?.form || (event.type === 'submit' ? event.target : null);
    if (!form) return;
    const checkout = button?.name === 'checkout' || event.submitter?.name === 'checkout' || form.getAttribute('id') === 'cart-form';
    if (!(checkout ? validateCart() : validateForm(form))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }
  window.ifServiceValidation = { rule, urlValid, validateForm, validCartRecord, validateCart };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('input', event => { if (event.target.matches('input,textarea')) clear(event.target); });
  function init() {
    validateCart();
    let queued = false;
    new MutationObserver(records => {
      if (queued || !records.some(r => r.type === 'attributes' || [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-service-cart-record],[data-service-checkout]') || n.querySelector?.('[data-service-cart-record],[data-service-checkout]'))))) return;
      queued = true; queueMicrotask(() => { queued = false; validateCart(); });
    }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-service-cart-record','data-checkout-blocked']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
